<template>
    <div>
        <SToolbar>
            <KpIcon icon-cls="user" color="grey" left />
            <v-toolbar-title>{{ $t('admin') }}</v-toolbar-title>
        </SToolbar>

        <UserList session-key="user-list" height="var(--usable-height-with-double-toolbar)" />
    </div>
</template>

<script>
import UserList from '@/components/user/List.vue';

export default {
    name: 'UserIndex',

    components: {
        UserList,
    },
};
</script>
